var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow 2",
    d: "M4.46967 15.4697C4.17678 15.7626 4.17678 16.2374 4.46967 16.5303C4.76256 16.8232 5.23744 16.8232 5.53033 16.5303L4.46967 15.4697ZM16.3566 5.3934C16.3566 4.97918 16.0208 4.6434 15.6066 4.6434L8.8566 4.6434C8.44239 4.6434 8.1066 4.97918 8.1066 5.3934C8.1066 5.80761 8.44239 6.1434 8.8566 6.1434H14.8566V12.1434C14.8566 12.5576 15.1924 12.8934 15.6066 12.8934C16.0208 12.8934 16.3566 12.5576 16.3566 12.1434L16.3566 5.3934ZM5.53033 16.5303L16.1369 5.92373L15.0763 4.86307L4.46967 15.4697L5.53033 16.5303Z",
    fill: "#225AAC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLink);
export default __webpack_public_path__ + "static/media/open-link.86a159e1fc793bf9a908dc49e761b1ec.svg";
export { ForwardRef as ReactComponent };